import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { siteInfo } from '../data/mockData';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { name: 'HOME', path: '/' },
    { name: 'QUEM SOMOS', path: '/quem-somos' },
    { name: 'FUNERAL', path: '/funeral' },
    { name: 'CREMAÇÃO', path: '/cremacao' },
    { name: 'TRANSLADO', path: '/translado' },
    { name: 'PUBLICAÇÕES', path: '/publicacoes' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black bg-opacity-80 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_funeraria-meier-rj/artifacts/8dv5zw1l_logp.jfif" 
              alt="Funerária do Meier Logo"
              className="w-16 h-16 rounded-full object-cover"
            />
            <div className="text-white">
              <div className="text-xl font-serif">{siteInfo.name.split(' ')[0]} {siteInfo.name.split(' ')[1]}</div>
              <div className="text-xs tracking-wider">{siteInfo.tagline}</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-teal-400 ${
                  location.pathname === item.path ? 'text-teal-400' : 'text-white'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contato"
              className="bg-teal-500 hover:bg-lime-600 text-white px-6 py-2 rounded-md text-sm font-medium transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/50"
            >
              CONTATO
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            className="lg:hidden text-white p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden pb-4 space-y-2">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block py-2 text-sm font-medium transition-colors hover:text-teal-400 ${
                  location.pathname === item.path ? 'text-teal-400' : 'text-white'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/contato"
              onClick={() => setMobileMenuOpen(false)}
              className="block bg-teal-500 hover:bg-lime-600 text-white px-6 py-2 rounded-md text-sm font-medium text-center transition-colors"
            >
              CONTATO
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
